import * as React from 'react';
import { IValidationConfig } from '../../helpers';
import { Label, Button, ButtonType } from 'office-ui-fabric-react';

interface IProps {
    validationItem: IValidationConfig;
	canDeleteItem: boolean;
	canEditItem: boolean;
    editButtonClick: () => void;
    deleteButtonClick: () => void;
}

export class ValidationItem extends React.Component<IProps, any> {

    public render() {

        let { validationItem, canDeleteItem, canEditItem, editButtonClick, deleteButtonClick } = this.props;

		return (
			<div>
				<Label className='h4'>
					{validationItem.ValidationName}
					{canEditItem && <Button
						className='branch-edit-button'
						buttonType={ ButtonType.icon }
						icon='Edit'
						onClick={editButtonClick}
					/>}
					{canDeleteItem && <Button
						className='branch-delete-button'
						buttonType={ ButtonType.icon }
						icon='Delete'
						onClick={deleteButtonClick}
					/>}					
				</Label>
			</div>
		);

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/validation/validation-item.tsx